import { DTOPromotionCodeResponse } from "vue-app/api/dto";
import axios from "vue-app/utils/axios";

export const getValidatePromotionCode = async (promotionCode: string) => {
  const { data } = await axios.get<DTOPromotionCodeResponse>(`/stripe/validate-promotion-code/${promotionCode}`);
  return data;
};
